module.exports = __webpack_public_path__ + "img/1470153879.60b77034.jpg";